import React from 'react';
import './App.css';
import { Routes, Route } from 'react-router-dom';
import { Home } from './components/Home';
import { Login } from './components/Login';
import { Register } from './components/Register';
import Comprobacion from './components/Comprobacion';
import { HomeUser } from './components/HomeUser';
import Ranking from './components/Ranking';
import { ResumenEntreno } from './components/ResumenEntreno';
import Historial from './components/Historial';
import { AuthProvider } from './context/authContext';
import { ProtectedRoute } from './components/ProtectedRoute';
import ComprarTokens from './components/ComprarTokens';
import ResetPassword from "./components/ResetPassword";

// 👉 IMPORTA el Toaster
import { Toaster } from 'react-hot-toast';

// 👉 IMPORTA el AdminPanel
import { AdminPanel } from './components/AdminPanel';

function App() {
  return (
    <div className='bg-slate-300 h-screen text-black flex'>
      <AuthProvider>
        {/* 🔥 AÑADIDO: Toaster global */}
        <Toaster position="top-center" reverseOrder={false} />

        <Routes>
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <Home />
              </ProtectedRoute>
            }
          />

          <Route
            path="/homeuser"
            element={
              <ProtectedRoute>
                <HomeUser />
              </ProtectedRoute>
            }
          />

          <Route
            path="/comprobacion"
            element={
              <ProtectedRoute>
                <Comprobacion />
              </ProtectedRoute>
            }
          />

          <Route
            path="/ranking"
            element={
              <ProtectedRoute>
                <Ranking />
              </ProtectedRoute>
            }
          />

          <Route
            path="/resumentreno"
            element={
              <ProtectedRoute>
                <ResumenEntreno />
              </ProtectedRoute>
            }
          />

          <Route
            path="/historial"
            element={
              <ProtectedRoute>
                <Historial />
              </ProtectedRoute>
            }
          />

          {/* 🚀 Nueva ruta para el admin */}
          <Route
            path="/admin"
            element={
              <ProtectedRoute>
                <AdminPanel />
              </ProtectedRoute>
            }
          />
          {/* 🚀 Nueva ruta comprar tokens */}
          <Route
            path="/comprar-tokens"
            element={
              <ProtectedRoute>
                <ComprarTokens />
              </ProtectedRoute>
            }
          />


          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />

          <Route path="/reset-password" element={<ResetPassword />} />

        </Routes>
      </AuthProvider>
    </div>
  );
}

export default App;
